import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/App";
import { avatarSrc } from "@/lib/avatar";
import { PROFILE_OPEN_EVENT, PROFILE_UPDATED_EVENT } from "@/components/ProfileCompletionPrompt";

const initials = (name) => (name || "").split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0].toUpperCase()).join("") || "?";

export const UserAvatar = ({ userId }) => {
  const [profile, setProfile] = useState(null);
  const [broken, setBroken] = useState(false);

  const load = useCallback(async () => {
    if (!userId || userId === "new") return;
    try {
      const r = await axios.get(`${API}/team/${userId}/me`);
      setProfile(r.data);
      setBroken(false);
    } catch (e) {
      console.error("Avatar load error:", e);
    }
  }, [userId]);

  useEffect(() => { load(); }, [load]);
  useEffect(() => {
    const onUpdate = (e) => (e.detail ? (setProfile(e.detail), setBroken(false)) : load());
    window.addEventListener(PROFILE_UPDATED_EVENT, onUpdate);
    return () => window.removeEventListener(PROFILE_UPDATED_EVENT, onUpdate);
  }, [load]);

  if (!userId || userId === "new") return null;
  const src = avatarSrc(profile?.photoUrl);
  const name = profile?.name && profile.name !== "Team Member" ? profile.name : "";
  return (
    <button
      onClick={() => window.dispatchEvent(new CustomEvent(PROFILE_OPEN_EVENT))}
      title={name ? `${name} · edit profile` : "Complete your profile"}
      className="relative h-9 w-9 rounded-full border border-white/10 bg-white/5 hover:border-ism-teal/60 transition-colors overflow-hidden flex items-center justify-center"
      data-testid="header-avatar-btn"
    >
      {src && !broken ? (
        <img src={src} alt={name || "Profile"} className="h-full w-full object-cover" onError={() => setBroken(true)} data-testid="header-avatar-img" />
      ) : (
        <span className="text-xs font-semibold text-ism-teal" data-testid="header-avatar-initials">{initials(name)}</span>
      )}
      {profile && !profile.profileComplete && (
        <span className="absolute -top-0.5 -right-0.5 h-2.5 w-2.5 rounded-full bg-amber-400 ring-2 ring-black" data-testid="header-avatar-incomplete-dot" />
      )}
    </button>
  );
};
